<template>
  <mu-card>
    <form @submit.prevent="submitForm">
      <mu-card-header titleClass="blueTitle largeTitle" title="Add a review of this recipe"
                      subTitle="Take a picture of the prepared recipe to share with the community"></mu-card-header>
      <mu-card-text style="padding-top:0">
        <recipe-rating :read-only="false" style="margin-bottom: 24px;" :count="recipe.rating.ratingCount"
                       :rating="recipe.rating.userRating" :recipe="recipe"
                       @ratingPicked="onRatingPicked"></recipe-rating>

        <div><textarea class="textAreaReview" rows="4"
                       style="min-width: 100%; min-height: 100px; max-width:100%;margin-bottom: 14px"
                       v-model="model.review"></textarea></div>
        <div v-if="isImagesUploading">
          Uploading images...
        </div>
        <img v-for="(image, index) in model.images"  :index="'images-' + index":src="image"
             style="height: 50px; border:1px solid white;margin-bottom: 8px;"/>
        <mu-row>
          <mu-col :width="50" :tablet="50" desktop="50" align="left">
            <multiple-image-uploader v-model="model.images" @uploading="onUploading"></multiple-image-uploader>
          </mu-col>
          <mu-col :width="50" :tablet="50" :desktop="50" align="right">
            <button type="submit" style="display: none;"></button>
            <mu-raised-button @click.native="submitForm" primary :disabled="isSaving"
                              :label="isSaving === false ? $t('message.submitText'): $t('message.savingText')"></mu-raised-button>
          </mu-col>
        </mu-row>
      </mu-card-text>
    </form>
    <mu-divider></mu-divider>
    <mu-list class="reviewList" v-if="$store.state.user.scope">
      <mu-list-item v-for="(item, rindex) in reviews.data" :key="item.user_id" :disableRipple="true">
        <mu-avatar
          v-if="!item.user.profile_large"
          slot="left"
          color="#0179d5"
          backgroundColor="#E9E9E8">
          {{upperTwoInitials(item.user.display_name)}}
        </mu-avatar>
        <mu-avatar
          v-else
          :src="item.user.profile_large"
          slot="left"
          color="white"
          backgroundColor="#E9E9E8"
          @click="goToProfile(question.url)"
        >
        </mu-avatar>
        <div slot="title">{{item.user.display_name}}</div>
        <div slot="describe" v-if="!item.isUpdateReviewOpen">

          <div style="margin-bottom: 8px">{{fromNow(item.createdAt)}}</div>
          <span v-for="(ratingI, rindex) in 5" v-bind:class="{'activeStar': item.rating.rating >= ratingI}"
                :key="'rating-' + rindex"
                style="color: rgb(204, 204, 204)">
            <mu-icon value="star"></mu-icon>
          </span>

          <div style="margin-bottom: 14px; margin-top: 14px;word-break: normal;" v-if="item">
            <vue-markdown :source="item.review"></vue-markdown>
          </div>

          <div>
            <img @click="openImg(image)" v-for="(image, iindex) in item.images" :key="'image-' + iindex" :src="image" style="height: 90px">
            <mu-dialog :open="imgModal" @close="closeImg">
              <img :src="imgModalSrc" style="width: 100%;">
              <mu-flat-button slot="actions" @click="closeImg" label="Close" />
            </mu-dialog>
          </div>

          <mu-list>
            <mu-list-item v-for="(comments, cindex) in item.comments" :key="'comment-' + cindex">
              <mu-avatar
                v-if="!comments.user.profile_large"
                slot="left"
                color="#0179d5"
                backgroundColor="#E9E9E8">
                {{upperTwoInitials(comments.user.display_name)}}
              </mu-avatar>
              <mu-avatar
                v-else
                :src="comments.user.profile_large"
                slot="left"
                color="white"
                backgroundColor="#E9E9E8"
                @click="goToProfile(question.url)"
              >
              </mu-avatar>
              <div slot="title">{{comments.user.display_name}}</div>
              <div slot="describe">
                <div style="margin-bottom: 8px">{{fromNow(comments.createdAt)}}</div>
                <span>
                     <vue-markdown :source="comments.body" style="white-space: pre-wrap;word-break:normal;"></vue-markdown>

                  </span>
                  <span v-if="comments.isUpdateCommentOpen">
                    <textarea class="textAreaReview" rows="4"
                          style="min-width: 100%; min-height: 100px; max-width:100%;margin-bottom: 14px;"
                          v-model="editableCommentModel[comments.id]"></textarea>
                          <div class="reply-block">
                            <mu-raised-button @click.native="showUpdateCommentBlock(comments)" label="Cancel"
                              ></mu-raised-button>
            <mu-raised-button @click.native="updateComment(comments)" label="Update"
                              primary></mu-raised-button>

          </div>
                  </span>
              </div>
              <mu-icon-menu v-if="comments.userId === $store.state.user.scope.user_id" slot="right"
                            icon="more_vert"
                            v-tooltop.left="'Options'">
                <mu-menu-item @click.native="editComment(comments)" title="Edit"/>
                <mu-menu-item @click.native="deleteComment(comments.id, item)" title="Delete"/>
              </mu-icon-menu>
            </mu-list-item>
          </mu-list>
          <div class="reply-block">
            <mu-raised-button @click.native="showReplyBlock(item)" :label="!item.isReplyOpen ? showReply : hideReply"
                              primary></mu-raised-button>
          </div>
          <div v-if="item.isReplyOpen" class="reviewCommentWrap">
            <form>
              <div class="reviewComment">
                <textarea class="textAreaReview" rows="4"
                          style="min-width: 100%; min-height: 100px; max-width:100%;margin-bottom: 14px;"
                          v-model="commentModel.body"></textarea>
              </div>
              <div>
                <mu-col :width="100" :tablet="100" :desktop="100" align="right">
                  <mu-raised-button @click.native="addComment(item)" label="Submit" primary></mu-raised-button>
                </mu-col>
              </div>
            </form>
          </div>
        </div>
        <div v-else>
          <div><textarea class="textAreaReview" rows="4"
                       style="min-width: 100%; min-height: 100px; max-width:100%;margin-bottom: 14px"
                       v-model="editableReviewModel[item.id].review"></textarea></div>
        <div v-if="isImagesUploadingForUpdate">
          Uploading images...
        </div>
        <div style="display: flex">
          <div v-for="(image, index) in model.updateImages">
          <img  :index="'images-' + index":src="image"
             style="height: 50px; border:1px solid white;margin-bottom: 8px;"/>
          <mu-icon size="16" value="close" style="verticalAlign: top; cursor: pointer" @click.native="removeImage(item, index)"></mu-icon>
        </div>
        </div>


        <mu-row>
          <mu-col :width="50" :tablet="50" desktop="50" align="left">
            <multiple-image-uploader v-model="model.updateImages" :existing-images="item.images" @uploading="onUploadingForUpdate"></multiple-image-uploader>
          </mu-col>
          <mu-col :width="50" :tablet="50" :desktop="50" align="right">
            <div class="reply-block">
                            <mu-raised-button @click.native="showUpdateReviewBlock(item)" label="Cancel"
                              ></mu-raised-button>
            <mu-raised-button @click.native="updateReview(item)" label="Update"
                              primary></mu-raised-button>

          </div>

          </mu-col>
        </mu-row>
        </div>
        <mu-icon-menu v-if="item.user_id === $store.state.user.scope.user_id" slot="right" icon="more_vert"
                             v-tooltop.left="'Options'">
          <mu-menu-item @click.native="editReview(item)" title="Edit"></mu-menu-item>
          <mu-menu-item @click.native="removeReview(item)" title="Delete"></mu-menu-item>
        </mu-icon-menu>
      </mu-list-item>
    </mu-list>
    <mu-card-actions
      v-if="reviews.paginationInfo.actualPage < reviews.paginationInfo.totalPages && reviews.data.length !== 0"
      align="center">
      <div v-if="!isAppending">
        <mu-raised-button @click.native="getReviews" label="Load more reviews"></mu-raised-button>
      </div>
      <div v-if="isAppending">
        <mu-circular-progress></mu-circular-progress>
        <br/>
        {{$t('message.loadingText')}}
      </div>
    </mu-card-actions>
  </mu-card>
</template>
<script>
  import moment from 'moment'
  import MultipleImageUploader from "./MultipleImageUploader";
  import RecipeRating from "./RecipeRating";
  import RecipeApi from '../../../api/Recipes'
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";

  export default {
    components: {
      MuCircularProgress,
      MuRaisedButton,
      RecipeRating,
      MultipleImageUploader,
    },
    name: "recipe-reviews",
    props: ['recipe'],
    data() {
      return {
        isImagesUploading: false,
        isAppending: false,
        isSaving: false,
        images: [],
        reviews: {
          paginationInfo: {
            actualPage: 0,
            itemsPerPage: 5,
            totalPages: 0,
            totalItems: 0
          },
          data: []
        },
        commentModel: {
          body: ""
        },
        editableReviewModel: {},
        editableCommentModel: {},
        reviewAdded: false,
        model: {
          recipe_id: null,
          images: [],
          updateImages: []
        },
        showReply: "Show reply box",
        hideReply: "Hide reply box",
        imgModal: false,
        isImagesUploadingForUpdate: false,
        imgModalSrc: null,
      }
    },
    watch: {
      '$route': 'getReviews',
      'recipe': 'getReviews'
    },
    mounted() {
      let self = this;
      self.getReviews();
    },
    methods: {
      openImg(img) {
        this.imgModalSrc = img;
        this.imgModal = true;
      },
      closeImg() {
        this.imgModal = false;
        this.imgModalSrc = null;
      },
      showReplyBlock(item) {
        item.isReplyOpen = !item.isReplyOpen;
        this.$forceUpdate();
      },
      showUpdateCommentBlock(comments) {
        comments.isUpdateCommentOpen = !comments.isUpdateCommentOpen;
        this.editableCommentModel = {
          ...this.editableCommentModel,
          [`${comments.id}`]: comments.body,
        }
        this.$forceUpdate();
      },
      showUpdateReviewBlock(item) {
        item.isUpdateReviewOpen = !item.isUpdateReviewOpen;
        if(item.isUpdateReviewOpen) {
          this.model.updateImages = item.images;
          this.editableReviewModel = {
            ...this.editableReviewModel,
            [`${item.id}`]: {
              "review": item.review,
              "isSaving": false
            },
          }
        }
        this.$forceUpdate();
      },
      fromNow(time) {
        return moment.utc(time).local().fromNow()
      },
      upperTwoInitials(displayName) {
        if(typeof(displayName) !== 'string') {
          return 'N/A'
        }

        if(displayName.length === 0) {
          return 'N/A';
        }

        return displayName.charAt(0).toUpperCase();
      },
      removeReview(review) {
        let self = this;
        let index = self.reviews.data.indexOf(review);
        self.$alert({
          title: "Are you sure?",
          text: "You are about to delete your recipe review",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return RecipeApi.deleteReview(review.id)
          }
        })
          .then(function () {
            self.$alert({
              title: "Success!",
              text: "Review was deleted",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
            self.reviews.data.splice(index, 1);
            self.$nextTick(() => {
              self.$forceUpdate();
            })
          }.bind(self))
          .catch(self.$alert.noop);
      },
      deleteComment(id, item) {
        let self = this;
        let index = item.comments.findIndex(x => x.id == id);

        self.$alert({
          title: "Are you sure?",
          text: "You are about to delete your comment",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return RecipeApi.deleteReviewComment(id);
          }
        })
          .then(function () {
            self.$alert({
              title: "Success!",
              text: "Comment was deleted",
              type: "success",
              showCancelButton: false,
              confirmButtonColour: "white"
            });
            item.comments.splice(index, 1);
            self.$forceUpdate();
          });
      },
      addComment(item) {
        let self = this;
        if (self.commentModel.body) {
          RecipeApi.postReviewComment(item.id, self.commentModel).then((res) => {
            if (item.comments === undefined) {
              item.comments = [res.data];
            } else {
              item.comments.push(res.data);
            }
            self.$nextTick(() => {
              self.$forceUpdate();
              self.commentModel.body = "";
            })
          })
        } else {
          alert('Please add a comment');
        }
      },
      getReviews() {
        let self = this;
        self.reviews.paginationInfo.actualPage++;
        self.isAppending = true;
        RecipeApi.reviews(self.recipe.id, {
          page: self.reviews.paginationInfo.actualPage,
          limit: self.reviews.paginationInfo.itemsPerPage
        })
          .then(function (response) {
            self.reviews.paginationInfo = response.data.paginationInfo;
            self.reviews.data.push.apply(self.reviews.data, response.data.data);

            self.reviews.data.forEach((item) => {
              item.isReplyOpen = false;
              item.addedByCurrentUser = false;
            });

            self.$nextTick(function () {
              self.isAppending = false;
            })
          })
      },
      submitForm() {
        let self = this;

        self.model.recipe_id = self.recipe.id;
        if (self.model.review == null || self.model.review.trim() === "") {
          alert('Please add a recipe review')
        } else {

          self.isSaving = true;
          RecipeApi.review(self.model).then(function (response) {
            self.isSaving = false;
            self.reviews.data.unshift(response.data);
            self.$forceUpdate();
            self.model.images = [];
            self.model.review = null;
            self.reviewAdded = true
          })
            .catch(function (error) {
              self.isSaving = false;
            });
        }
      },
      onRatingPicked(rating) {
        this.$emit('ratingPicked', rating)
      },
      onUploading(state) {
        this.isImagesUploading = state;
      },
      onUploadingForUpdate(state) {
        this.isImagesUploadingForUpdate = state;
      },
      editComment(comments) {
        this.showUpdateCommentBlock(comments)
      },
      updateComment(comments) {
        let self = this;
        if (self.editableCommentModel[comments.id]) {
          RecipeApi.updateReviewComment(comments.id, {body: self.editableCommentModel[comments.id]}).then((res) => {
            comments.body = self.editableCommentModel[comments.id]
            this.showUpdateCommentBlock(comments)
          })
        }
      },
      editReview(item) {
        this.showUpdateReviewBlock(item)
      },
      updateReview(item) {
        let self = this;

        if (self.editableReviewModel[item.id].review == null || self.editableReviewModel[item.id].review.trim() === "") {
          alert('Please add a recipe review')
        } else {
          const updateReviewModel = {
            review: self.editableReviewModel[item.id].review
          }

          // use the new images uploaded by the user
          if(self.model.updateImages.length > 0) {
            updateReviewModel["images"] = self.model.updateImages
          } else {
            // or use the images left on the item itself
            updateReviewModel["images"] = item.images
          }
          self.editableReviewModel[item.id].isSaving = true;
          RecipeApi.updateReview(item.id, updateReviewModel).then(response => {
            self.editableReviewModel[item.id].isSaving = false;
            item.review = self.editableReviewModel[item.id].review;
            if(self.model.updateImages.length > 0) {
              item.images = self.model.updateImages
            }
            this.showUpdateReviewBlock(item)
            self.model.updateImages = [];
            self.editableReviewModel[item.id].review = null;
          })
          .catch(function (error) {
              self.editableReviewModel[item.id].isSaving = false;
          });
        }
      },
      removeImage(item, index) {
        item.images.splice(index, 1)
      }
    }
  }
</script>

<style>
  .reviewComment {
    padding: 1px;
  }

  .reply-block {
    text-align: right;
    margin-top: 25px;
  }

  .reviewCommentWrap {
    margin-top: 25px;
  }

  .showCommentBtn {
    margin: 25px 0 5px;
  }

  .activeStar {
    color: gold !important;
  }

  .mu-list.reviewList .mu-item-text {
    height: auto !important;
    max-height: inherit !important;
    -webkit-line-clamp: inherit !important;
  }

  .textAreaReview {
    max-height: 300px;
    border: 1px solid #cacaca;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// RecipeReviews.vue?e72e1000